import { Validator } from 'vee-validate'

Validator.extend('nomeUnico', {
    getMessage: () => `A opção deve ser única.`,
    validate: (nome, opcoes) => {
        return opcoes.filter((opcao) => opcao.nome.toLowerCase() === nome.toLowerCase()).length <= 1
    }
})
